import React from 'react'
import { useEffect, useState, useRef } from 'react'
import TableList from './TableListViewComponent';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import './css/inventory.css'
import { InputAdornment } from '@material-ui/core';
import OdooDatabase from '../data/odoo'
import Loading from './LoadingComponent'
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography'
import * as MdIcons from "react-icons/md";
import * as AiIcons from "react-icons/ai"


type InventoryProperties = {
    onMount?(): void;
    onUnmount?(): void;
}

function Inventory(props: InventoryProperties){

    const [searchText, setSearchText] = useState('')
    const [tableKey, setTableKey] = useState(0)
    const [timeOut, setTimeOut] = useState(0)
    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState<any[]>([])
    const [loading, setLoading] = useState(false)
    const mountedRef = useRef(true)

    const filterData = (fulldata: any[]) => {
        const newData = fulldata.filter((obj: any) => {
            return obj.part.toLocaleLowerCase().indexOf(searchText.toLocaleLowerCase()) >= 0
        })
        return newData
    }

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            let newData = filterData(data)
            setFilteredData(newData)
            setTableKey(1 - tableKey)
            setTimeOut(500)
        }, timeOut)

        return () => clearTimeout(delayDebounceFn)
      }, [searchText])

    const onSearchTextChange = (event: any) => {
        setSearchText(event.target.value)
    }

    const processInventory = (data: any[]) => {
        data.forEach((item: any) => {
            item.on_hand = `${item.on_hand} ${item.uom}`;
            item.available_on_hand = `${item.available_on_hand} ${item.uom}`;
            let reference = item.reference
            if(reference)
                reference = `[${reference}]`
            if(item.description){
                item.part = `${reference} ${item.name} - ${item.description}`
            } else {
                item.part = `${reference} ${item.name}`
            }
        })
    }

    const loadData = async () => {
        const odoo = OdooDatabase.getInstance()
        try{
            setLoading(true)
            let data = await odoo.execute_kw('fieldservice.workorder', 'get_products_in_tech_truck', [[false, '']])
            if (!mountedRef.current) return
            processInventory(data)
            setData(data)
            const newData = filterData(data)
            setFilteredData(newData)
            setTableKey(1 - tableKey)
            setLoading(false)
        }catch(err: any){
            console.log('Error', err);
            if (!mountedRef.current) return
            setLoading(false)
        }
    }

    useEffect(() => {
        if(props.onMount){
            props.onMount()
        }
        loadData()
        return () => {
            mountedRef.current = false
            if(props.onUnmount)
                props.onUnmount()
        }
    }, [])

    return (
        <Paper elevation={3} className="woitem" >
            <Typography>Truck Inventory</Typography>
            <div className="search_box">
                <TextField type="text" variant="filled" autoComplete="off" label="Search"
                    value={searchText}
                    onChange={onSearchTextChange}
                    InputProps={{
                        endAdornment: searchText !== '' ?
                            (
                                <InputAdornment position="end">
                                    <IconButton onClick={()=>{setSearchText('')}}><AiIcons.AiFillCloseCircle/></IconButton>
                                </InputAdornment>
                            ) :
                            (<></>)
                    }}
                >
                </TextField>
                <IconButton onClick={()=>{loadData()}}><MdIcons.MdRefresh className="refresh_icon" size={30}/></IconButton>
            </div>
            {loading ?
                (<Loading loading={true} fullWidth={false}/>):
                (<>
                <TableList
                    key={tableKey}
                    showInitialData={true}
                    initialData={filteredData}
                    elements={[{field:'part', type: 'string', header: 'Part'},
                            {field: 'on_hand', type: 'string', header: 'On Hand'},
                            {field: 'available_on_hand', type: 'string', header: 'Available'},
                            ]}>
                </TableList>
                </>)
            }
        </Paper>)
}

export default Inventory;